__turbopack_context__.v({
  "YouTubeVideo": "xKW7dG_YouTubeVideo",
  "YouTubeVideo--Manual": "xKW7dG_YouTubeVideo--Manual",
  "YouTubeVideo--Padding": "xKW7dG_YouTubeVideo--Padding",
  "YouTubeVideo__Button": "xKW7dG_YouTubeVideo__Button",
  "YouTubeVideo__Media": "xKW7dG_YouTubeVideo__Media",
  "YouTubeVideo__Ratio": "xKW7dG_YouTubeVideo__Ratio",
  "YouTubeVideo__Ratio--Cover": "xKW7dG_YouTubeVideo__Ratio--Cover",
  "YouTubeVideo__TargetButtonWrap": "xKW7dG_YouTubeVideo__TargetButtonWrap",
  "YouTubeVideo__TargetTitle": "xKW7dG_YouTubeVideo__TargetTitle",
  "YouTubeVideo__Title": "xKW7dG_YouTubeVideo__Title",
  "YouTubeVideo__Wrap": "xKW7dG_YouTubeVideo__Wrap",
  "YouTubeVideo__Wrap--Gradient": "xKW7dG_YouTubeVideo__Wrap--Gradient",
  "YouTubeVideo__Wrap--Target": "xKW7dG_YouTubeVideo__Wrap--Target",
});
